export default {"src":"/_next/static/media/wide-logo-color.e7042be7.svg","height":702,"width":3162,"blurWidth":0,"blurHeight":0};